module.exports = __webpack_public_path__ + "static/media/click hand.81c61663.png";